import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { TWarningAlertProps } from './types';

export const WarningAlert: FC<TWarningAlertProps> = ({ children }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				mt: 1,
				backgroundColor: '#de000024', // '#0092de24',
				borderRadius: '12px',
				padding: '10px',
				height: 'auto',
			}}
		>
			<Typography sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#000000d0', ml: '10px' }}>
				{children}
			</Typography>
		</Box>
	);
};
